import { createContext, useContext, useEffect, useMemo, useState } from 'react';

const LanguageContext = createContext(null);
const STORAGE_KEY = 'kalamanch_language';

const getInitialLanguage = () => {
  if (typeof window === 'undefined') return 'en';
  try {
    return window.localStorage.getItem(STORAGE_KEY) || 'en';
  } catch (error) {
    return 'en';
  }
};

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(getInitialLanguage);

  useEffect(() => {
    try {
      window.localStorage.setItem(STORAGE_KEY, language);
    } catch (error) {
      // Language preference is a convenience, so the site should keep working without storage.
    }
    document.documentElement.lang = language === 'hi' ? 'hi' : 'en';
  }, [language]);

  const value = useMemo(() => ({
    language,
    isHindi: language === 'hi',
    setLanguage,
    toggleLanguage: () => setLanguage((current) => (current === 'hi' ? 'en' : 'hi')),
  }), [language]);

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    return {
      language: 'en',
      isHindi: false,
      setLanguage: () => {},
      toggleLanguage: () => {},
    };
  }
  return context;
};
